import React, { useEffect, useState } from "react";
import { FormGroup, Button, Container } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import Breadcrumbs from "../../components/Common/Breadcrumb";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import { AxiosError } from "axios";

import { z } from "zod";
import { FetchHouseTypes } from "../../apis/HouseType";
import { CreateFee } from "../../apis/Fee";

export const commissionFeeSchema = z.object({
  propertyType: z.string().min(1, "Property type is required."),
  value: z.coerce
    .number({
      required_error: "Value is required.",
      invalid_type_error: "Value must be a number.",
    })
    .min(0, "Value cannot be negative."),
});

const AddCommissionFee = () => {
  const [value, setValue] = useState();
  const [propertyType, setPropertyType] = useState();
  const [propertyTypes, setPropertyTypes] = useState([]);
  const [errors, setErrors] = useState([]);

  const navigate = useNavigate();

  const breadcrumbItems = [
    { title: "Dashboard", link: "/" },
    { title: "Commission Fee", link: "#" },
  ];

  const fetchPropertyTypes = async () => {
    const response = await FetchHouseTypes();
    console.log("response.data.propertyTypes", response.data.propertyTypes);
    setPropertyTypes(response.data.propertyTypes);
  };

  useEffect(() => {
    fetchPropertyTypes();
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const data = {
        feeType: "commission",
        valueType: "percentage",
        value,
        applyOn: [
          {
            target: "host",
            context: "payout",
          },
        ],
        conditions: {
          propertyType,
        },
        priority: 1,
      };

      const validationResult = commissionFeeSchema.safeParse({
        value,
        propertyType,
      });

      if (!validationResult.success) {
        const fieldErrors = {};
        validationResult.error.errors.forEach((error) => {
          if (error.path.includes("value")) {
            fieldErrors.value = error.message;
          } else if (error.path.includes("propertyType")) {
            fieldErrors.propertyType = error.message;
          }
        });
        setErrors(fieldErrors);
        return;
      }

      const response = await CreateFee(data);
      if (response) {
        toast.success("Commission Fee Created Successfully");
        navigate("/commission-fees");
      } else {
        toast.error("Commission Fee Creation Failed");
      }
    } catch (error) {
      if (error instanceof AxiosError) {
        toast.error(error.response.data.message);
      } else {
        toast.error("An unexpected error occurred. Please try again later.");
      }
    }
  };

  return (
    <React.Fragment>
      <div className="page-content">
      <Container className="px-0 dark:bg-darkBg1 dark:text-[#c7d8eb]" fluid>
        <Breadcrumbs
          title="Add Commission Fee"
          breadcrumbItems={breadcrumbItems}
        />
        <div className="p-6 flex flex-col gap-6 ">
          <h1 className="text-2xl dark:text-[#c7d8eb]">Add Commission Fee</h1>
          <div className="lg:flex flex-col w-full lg:max-w-4xl mx-auto p-4 lg:rounded-lg lg:border border-gray-400 dark:border-white">
            <AvForm onValidSubmit={handleSubmit}>
              <div className="mb-3">
                <AvField
                  className="dark:!bg-darkBg1 dark:!text-[#c7d8eb] dark:!border-white dark:placeholder:!text-[#c7d8eb]"
                  name="value"
                  label="Commission Fee Value"
                  placeholder="Type Commission Fee Value"
                  type="number"
                  validate={{
                    required: { value: true },
                    pattern: {
                      value: /^\d+(\.\d{1,2})?$/,
                      errorMessage:
                        "Only numbers with up to 2 decimal places allowed",
                    },
                    min: {
                      value: 1,
                    },
                    max: {
                      value: 100,
                    },
                  }}
                  onChange={(e) => setValue(e.target.value)}
                />
                <div className="flex flex-col gap-1 mt-1">
                  {errors.value && (
                    <p className="mt-1 text-red-600">{errors.value}</p>
                  )}
                </div>
              </div>
              <div className="mb-3">
                <h2 className="text-xl dark:text-[#c7d8eb]">
                  <label htmlFor="role">Property Type</label>
                </h2>
                <div className="flex flex-col gap-1 mt-1">
                  {errors.propertyType && (
                    <p className="mt-1 text-red-600">{errors.propertyType}</p>
                  )}
                </div>
                <select
                  id="role"
                  value={propertyType}
                  defaultValue={""}
                  onChange={(e) => setPropertyType(e.target.value)}
                  className="px-4 py-3 border border-gray-500 dark:border-white rounded-sm dark:bg-darkBg1"
                >
                  <option value={""} disabled selected>
                    Select Property Type
                  </option>
                  {propertyTypes.map((propertyType) => (
                    <option value={propertyType._id} key={propertyType._id}>
                      {propertyType.itemName.en}
                    </option>
                  ))}
                </select>
              </div>
              <FormGroup className="mb-0">
                <div>
                  <Button type="submit" color="primary" className="me-1">
                    Add
                  </Button>
                </div>
              </FormGroup>
            </AvForm>
          </div>
        </div>
      </Container>
      </div>
    </React.Fragment>
  );
};

export default AddCommissionFee;
